import { ImagePreview } from 'components/common/Image/ImagePreview';
import { VideoPreview } from 'components/common/Video/VideoPreview';
import { Trans } from 'react-i18next';
import styles from './lineMessageRenderMethod.module.scss';
import i18n from 'i18n';

export const renderImageMessage = (image: FileFieldData) => {
  return (
    <ImagePreview
      className={styles.imagePreview}
      file={image.file}
      url={image.url}
      config={{
        showName: false,
        showSize: false
      }}
    />
  );
};

export const renderVideoMessage = (
  video: FileFieldData,
  previewImage: FileFieldData
) => {
  return (
    <>
      <VideoPreview
        maxWidth={600}
        maxHeight={600}
        src={video.file || video.url}
      />
      <ImagePreview
        className={styles.imagePreview}
        file={previewImage.file}
        url={previewImage.url}
        config={{
          showName: false,
          showSize: false
        }}
      />
    </>
  );
};

export const renderJoinMessage = (officialAccount: string) => {
  return (
    <Trans
      i18nKey='creativeSummaryStep.labels.join'
      values={{ value: officialAccount }}
      components={{ 1: <span className={styles.bold} /> }}
    />
  );
};

export const renderCouponMessage = (couponId: string) => {
  return (
    <Trans
      i18nKey='creativeSummaryStep.labels.coupon'
      values={{ value: i18n.t(`lineBeaconCoupons.${couponId}`) }}
      components={{ 1: <span className={styles.bold} /> }}
    />
  );
};
